export class QRButton {
  hierarchy!: string;
  size!: number;
  viewValue?: string | number;
  icon?: string;
  iconOnly?: boolean = false; // Para botones redondos en donde solo se ve el icono sin texto
  isBackgroundTransparent?: boolean = false;
  id?: number | string;
  type?: string = QRButton.TYPE_BUTTON;
  loader?: string = QRButton.LOADER_SPINNER;
  /**
   * When true, loader UI (shimmer/spinner) only shows if the parent also sets
   * [isSubmitReady]="true" on qr-button (e.g. movement dialogs with incomplete forms).
   */
  loaderOnlyWhenSubmitReady?: boolean;
  // Hierarchy
  public static readonly HIERARCHY_1: string = 'hierarchy-1';
  public static readonly HIERARCHY_2: string = 'hierarchy-2';
  public static readonly HIERARCHY_3: string = 'hierarchy-3';
  public static readonly HIERARCHY_4: string = 'hierarchy-4';
  public static readonly HIERARCHY_5: string = 'hierarchy-5';
  public static readonly HIERARCHY_ERROR: string = 'hierarchy-error';
  public static readonly HIERARCHY_WHATSAPP_1: string = 'hierarchy-whatsapp-1';
  public static readonly HIERARCHY_LIGHT: string = 'hierarchy-light';
  // Size
  public static readonly SIZE_MEDIUM: number = 40;
  public static readonly SIZE_SMALL: number = 32;

  // Type
  public static readonly TYPE_BUTTON: string = 'button';
  public static readonly TYPE_SUBMIT: string = 'submit';

  // Loader
  // Default: swaps the button content for a centered mat-spinner.
  public static readonly LOADER_SPINNER: string = 'loader-spinner';
  // Opt-in: keeps the label and sweeps a highlight across the background.
  // Only supported on hierarchies 1, light, 3 and 5 and on non iconOnly buttons;
  // any other combination falls back to LOADER_SPINNER.
  public static readonly LOADER_SHIMMER: string = 'loader-shimmer';
}
